import styled from 'styled-components';

import { ProductsGrid } from '@common/components/ProductsGrid/ProductsGrid.styled';

export const DividerContainer = styled.div`
  grid-column: 1 / -1;
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'scale', 17)};
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'scale', 17)};
  width: 100%;
`;

export const ProductsGridStyled = styled(ProductsGrid)`
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'scale', 0)};
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'section', 3)};
`;
